import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    flightplans: {},
    tracks: {},
    sectorTracks: {},
    quicklookTracks: {},
    coordinationData: {},
    cpdlcSessions: {},
    terminatedCpdlcSessions: {},
    stcaPairs: [],
    suppressedConflictPairs: [],
};
export const aircraftSlice = createSlice({
    name: "aircraft",
    initialState,
    reducers: {
        resetAircraftState() {
            return initialState;
        },
        deleteFlightplan(state, action) {
            delete state.flightplans[action.payload];
        },
        setFlightplans(state, action) {
            for (const fp of action.payload) {
                state.flightplans[fp.id] = fp;
            }
        },
        setFlightplan(state, action) {
            state.flightplans[action.payload.id] = action.payload;
        },
        updateFlightplans(state, action) {
            for (const { id, ...fields } of action.payload) {
                if (id in state.flightplans) {
                    Object.assign(state.flightplans[id], fields);
                }
            }
        },
        setStcaPairs(state, action) {
            state.stcaPairs = action.payload;
        },
        updateCoordination(state, action) {
            for (const [id, data] of Object.entries(action.payload)) {
                state.coordinationData[id] = data;
            }
        },
        setAllTracks(state, action) {
            state.tracks = action.payload;
        },
        setTracks(state, action) {
            for (const track of action.payload) {
                state.tracks[track.id] = track;
            }
        },
        setTrack(state, action) {
            state.tracks[action.payload.id] = action.payload;
        },
        updateTracks(state, action) {
            for (const track of action.payload) {
                if (track.id in state.tracks) {
                    Object.assign(state.tracks[track.id], track);
                }
            }
        },
        updateTrack(state, action) {
            const track = action.payload;
            Object.assign(state.tracks[track.id], track);
        },
        deleteFlightplans(state, action) {
            for (const id of action.payload) {
                delete state.flightplans[id];
            }
        },
        deleteTracks(state, action) {
            for (const id of action.payload) {
                delete state.tracks[id];
                delete state.sectorTracks[id];
            }
        },
        setCpdlcSessions(state, action) {
            Object.assign(state.cpdlcSessions, action.payload);
        },
        terminateCpdlcSessions(state, action) {
            for (const id of action.payload) {
                if (id in state.cpdlcSessions) {
                    state.terminatedCpdlcSessions[id] = state.cpdlcSessions[id];
                    delete state.cpdlcSessions[id];
                }
            }
        },
        setTerminatedCpdlcSessions(state, action) {
            Object.assign(state.terminatedCpdlcSessions, action.payload);
        },
        deleteCpdlcSessions(state, action) {
            for (const id of action.payload) {
                delete state.cpdlcSessions[id];
                delete state.terminatedCpdlcSessions[id];
            }
        },
        setCpdlcSession(state, action) {
            const { id, session } = action.payload;
            state.cpdlcSessions[id] = session;
        },
        setCpdlcSessionEligibility(state, action) {
            for (const [id, data] of Object.entries(action.payload)) {
                const session = state.cpdlcSessions[id];
                if (session) {
                    session.sessionState = "CDA";
                    session.logicalDataAuthority = data.logicalDataAuthority;
                    session.eligibleSectorId = data.eligibleSectorId;
                }
            }
        },
        setCpdlcDialogs(state, action) {
            for (const [id, dialogs] of Object.entries(action.payload)) {
                for (const dialog of Object.values(dialogs)) {
                    if (state.cpdlcSessions[id]?.dialogMap) {
                        state.cpdlcSessions[id].dialogMap[dialog.id] = dialog;
                    }
                }
            }
        },
        deleteSectorTracks(state, action) {
            for (const trackId of action.payload) {
                delete state.sectorTracks[trackId];
            }
        },
        setSectorTracks(state, action) {
            for (const track of action.payload) {
                if (track.tempFdb) {
                    track.dbType = "FDB";
                }
                state.sectorTracks[track.trackId] = track;
            }
        },
        setQuicklookTracks(state, action) {
            for (const track of action.payload) {
                state.quicklookTracks[track.trackId] = track;
            }
        },
        deleteQuicklookTracks(state, action) {
            for (const trackId of action.payload) {
                delete state.quicklookTracks[trackId];
            }
        },
        setSuppressedConflictPairs(state, action) {
            state.suppressedConflictPairs = action.payload;
        },
    },
});
export const aircraftReducer = aircraftSlice.reducer;
export const { setFlightplans, setFlightplan, updateFlightplans, deleteFlightplans, updateCoordination, setTracks, setAllTracks, updateTracks, updateTrack, deleteTracks, setStcaPairs, setTerminatedCpdlcSessions, setCpdlcSessions, setCpdlcSession, setCpdlcDialogs, setCpdlcSessionEligibility, terminateCpdlcSessions, deleteCpdlcSessions, deleteSectorTracks, deleteQuicklookTracks, setSectorTracks, setQuicklookTracks, setSuppressedConflictPairs, resetAircraftState, } = aircraftSlice.actions;
//# sourceMappingURL=aircraftSlice.js.map